// ===================================
// STICKY BAR AGGIORNATA - PAOLINA ROMA
// ===================================

(function() {
    'use strict';
    
    // Stato globale
    const stickyState = {
        initialized: false,
        charmPrices: {},
        currentCharms: [],
        updateTimer: null
    };
    
    // Inizializzazione principale
    function initStickyBar() {
        // Verifica se siamo nella pagina prodotto con configuratore
        const hasConfigurator = document.querySelector(
            '#product-builder, .cpb-product-builder, .cpb-root, [data-cpb-product-id]'
        );
        
        if (!hasConfigurator) {
            console.log('Paolina Sticky: Configuratore non trovato');
            return;
        }
        
        if (stickyState.initialized) {
            console.log('Paolina Sticky: Già inizializzata');
            return;
        }
        
        console.log('Paolina Sticky: Inizializzazione...');
        
        // Crea la struttura HTML
        createStickyBarHTML();
        
        // Setup degli eventi con delay per CPB
        setTimeout(() => {
            setupEventListeners();
            setupPriceSync();
            startCharmMonitoring();
            stickyState.initialized = true;
        }, 2000);
    }
    
    // Crea la struttura HTML della sticky bar
    function createStickyBarHTML() {
        // Rimuovi se esiste già
        const existing = document.querySelector('.cpb-sticky-bar');
        if (existing) existing.remove();
        
        const stickyBar = document.createElement('div');
        stickyBar.className = 'cpb-sticky-bar';
        stickyBar.innerHTML = `
            <div class="cpb-sticky-bar-inner">
                <div class="cpb-sticky-price">
                    <span class="cpb-sticky-price-label">Total:</span>
                    <span class="cpb-sticky-price-value">€25.00</span>
                </div>
                
                <div class="cpb-sticky-charms">
                    <div class="cpb-sticky-charms-placeholder">Pick your charms...</div>
                </div>
                
                <div class="cpb-sticky-cta">
                    <button type="button">
                        <svg class="cpb-sticky-cart-icon" viewBox="0 0 24 24" fill="none">
                            <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z" fill="currentColor"/>
                            <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z" fill="currentColor"/>
                            <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>ADD TO CART</span>
                    </button>
                </div>
            </div>
        `;
        
        document.body.appendChild(stickyBar);
        document.body.classList.add('has-cpb-sticky');
    }
    
    // Monitora i charm selezionati
    function startCharmMonitoring() {
        console.log('Paolina Sticky: Avvio monitoraggio charm...');
        
        // Update iniziale
        updateCharmsDisplay();
        
        // Click listener globale più robusto
        document.addEventListener('click', function(e) {
            // Cerca l'opzione cliccata in modo più ampio
            const option = e.target.closest(
                '.cpb-option, [class*="option"], [data-option-id], [role="option"]'
            );
            
            if (option) {
                clearTimeout(stickyState.updateTimer);
                stickyState.updateTimer = setTimeout(updateCharmsDisplay, 150);
            }
        }, true);
        
        // MutationObserver per cambiamenti di classe
        setupClassObserver();
        
        // Polling di backup ogni secondo
        setInterval(updateCharmsDisplay, 1000);
    }
    
    // Observer per cambiamenti nelle classi
    function setupClassObserver() {
        const targetNode = document.querySelector('#product-builder, .cpb-root');
        if (!targetNode) return;
        
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'attributes' && 
                    mutation.attributeName === 'class') {
                    
                    const target = mutation.target;
                    if (target.classList && (
                        target.classList.contains('cpb-option') ||
                        target.className.includes('option')
                    )) {
                        clearTimeout(stickyState.updateTimer);
                        stickyState.updateTimer = setTimeout(updateCharmsDisplay, 100);
                        break;
                    }
                }
            }
        });
        
        observer.observe(targetNode, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true
        });
    }
    
    // Aggiorna display dei charm
    function updateCharmsDisplay() {
        const container = document.querySelector('.cpb-sticky-charms');
        if (!container) return;
        
        // Trova tutti i charm attivi (salta i primi 2 che sono le catene)
const activeOptions = Array.from(document.querySelectorAll(
    '.cpb-option.cpb-active, .cpb-option.active, [class*="option"][class*="active"]'
)).slice(3);  // Cambiato da slice(1) a slice(2)
        
        // Se non ci sono charm
        if (activeOptions.length === 0) {
            if (!container.querySelector('.cpb-sticky-charms-placeholder')) {
                container.innerHTML = '<div class="cpb-sticky-charms-placeholder">Seleziona i tuoi charm...</div>';
            }
            return;
        }
        
        // Rimuovi placeholder
        const placeholder = container.querySelector('.cpb-sticky-charms-placeholder');
        if (placeholder) placeholder.remove();
        
        // Aggiorna o crea charm items
        const existingItems = container.querySelectorAll('.cpb-sticky-charm-item');
        
        activeOptions.forEach((option, index) => {
            const img = option.querySelector('img, .cpb-option-tooltip-img');
            const label = option.querySelector('.cpb-option-label, [class*="label"]');
            
            if (img) {
                // Se esiste già l'item, aggiornalo
                if (existingItems[index]) {
                    const existingImg = existingItems[index].querySelector('img');
                    if (existingImg.src !== img.src) {
                        existingImg.src = img.src;
                    }
                } else {
                    // Crea nuovo item
                    const charmItem = createCharmItem(
                        img.src,
                        label ? label.textContent : `Charm ${index + 1}`,
                        index + 1
                    );
                    container.appendChild(charmItem);
                }
            }
        });
        
        // Rimuovi items in eccesso
        for (let i = activeOptions.length; i < existingItems.length; i++) {
            existingItems[i].remove();
        }
    }
    
    // Crea elemento charm
    function createCharmItem(imgSrc, label, position) {
        const item = document.createElement('div');
        item.className = 'cpb-sticky-charm-item';
        item.innerHTML = `
            <img src="${imgSrc}" alt="${label}" />
            <span class="cpb-sticky-charm-position">${position}</span>
            <div class="cpb-price-tooltip">
                <div class="cpb-price-tooltip-content">
                    <span class="cpb-price-tooltip-label">${label}</span>
                    <span class="cpb-price-tooltip-price">€5.00</span>
                </div>
            </div>
        `;
        return item;
    }
    
    // Setup eventi
    function setupEventListeners() {
        // Bottone Add to Cart
        const stickyButton = document.querySelector('.cpb-sticky-cta button');
        if (stickyButton) {
            stickyButton.addEventListener('click', handleAddToCart);
        }
    }
    
    // Gestisce Add to Cart ottimizzato
    function handleAddToCart(e) {
        e.preventDefault();
        
        const button = e.currentTarget;
        const originalText = '<span>ADD TO CART</span>'; // O riprendi l'HTML originale se preferisci
        const loadingHTML = '<span class="cpb-sticky-loading"></span> ADDING...';
        
        // 1. Prevenire doppi click immediati
        if (button.disabled || button.classList.contains('loading')) return;

        // 2. Feedback visivo immediato
        button.innerHTML = loadingHTML;
        button.classList.add('loading');
        // Non disabilitiamo completamente il button nativo per non bloccare eventi, 
        // ma rendiamo il nostro bottone sticky non cliccabile visivamente
        button.style.pointerEvents = 'none'; 
        
        // 3. Cerca il bottone originazle del CPB
        const originalButton = document.querySelector(
            '.cpb-add-to-cart-button, button[class*="add-to-cart"], [data-add-to-cart]'
        );
        
        if (originalButton) {
            // Clicca il bottone reale
            originalButton.click();
            
            // 4. Gestione del "Dopo il click"
            // Poiché non possiamo agganciarci facilmente all'evento di successo dell'app esterna senza conoscere le loro API,
            // usiamo un timer di sicurezza più lungo per resettare il bottone,
            // dando tempo all'app di completare l'operazione AJAX.
            
            setTimeout(() => {
                button.innerHTML = '✓ ADDED!';
                button.style.backgroundColor = '#3E491C'; // Mantieni verde scuro
                
                setTimeout(() => {
                    // Reset totale
                    button.innerHTML = `
                        <svg class="cpb-sticky-cart-icon" viewBox="0 0 24 24" fill="none">
                            <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z" fill="currentColor"/>
                            <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z" fill="currentColor"/>
                            <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>ADD TO CART</span>
                    `;
                    button.classList.remove('loading');
                    button.style.pointerEvents = 'auto';
                }, 3000); // Mostra "Added" per 2 secondi
            }, 3000); // Aspetta 2.5s prima di dire "Added" (tempo medio generazione immagine)
            
        } else {
            // Fallback se non trova il bottone
            const form = document.querySelector('form[action*="/cart/add"]');
            if (form) form.submit();
        }
    }
    
    // Sincronizza prezzo
    function setupPriceSync() {
        const updatePrice = () => {
            const sources = [
                '.cpb-product-price',
                '.cpb-product-full-price [data-testid="multycurrency-price"]',
                '[class*="product-price"]',
                '.price'
            ];
            
            let priceEl = null;
            for (const selector of sources) {
                priceEl = document.querySelector(selector);
                if (priceEl) break;
            }
            
            const targetEl = document.querySelector('.cpb-sticky-price-value');
            
            if (priceEl && targetEl) {
                let price = priceEl.textContent.trim();
                price = price.replace(',', '.');
                if (!price.includes('€')) price = '€' + price;
                targetEl.textContent = price;
            }
        };
        
        // Update iniziale
        updatePrice();
        
        // Observer per cambiamenti prezzo
        const priceContainer = document.querySelector(
            '.cpb-product-full-price, .cpb-product-price, [class*="price-container"]'
        );
        
        if (priceContainer) {
            const observer = new MutationObserver(updatePrice);
            observer.observe(priceContainer, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }
        
        // Update su click opzioni
        document.addEventListener('click', (e) => {
            if (e.target.closest('.cpb-option, [class*="option"]')) {
                setTimeout(updatePrice, 300);
            }
        });
    }
    
    // INIZIALIZZAZIONE
    function init() {
        // Aspetta che il DOM sia pronto
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(initStickyBar, 1000);
            });
        } else {
            setTimeout(initStickyBar, 500);
        }
        
        // Reinizializza se CPB si carica dopo
        document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', initStickyBar);
        
        // Backup su window load
        window.addEventListener('load', () => {
            setTimeout(() => {
                if (!document.querySelector('.cpb-sticky-bar')) {
                    initStickyBar();
                }
            }, 2000);
        });
    }
    
    // Avvia
    init();
    
})();







// ===================================
// AUTO-AVANZAMENTO STEP - PAOLINA ROMA
// VERSIONE PULITA (zero CSS, solo logica)
// ===================================

(function() {
    'use strict';
    
    const AutoStepAdvance = {
        initialized: false,
        isManualChange: false,
        lastActiveCount: 0,
        changeTimeout: null,
        observerActive: false,
        maxSteps: null,
        
        config: {
            skipFirstOptions: 2,
            delayBeforeAdvance: 150,
            manualChangeDelay: 300,
            endBehavior: 'stop',  // 'loop' o 'stop'
        },
        
        calculateMaxSteps() {
            const panels = document.querySelectorAll('.cpb-panel-wrapper');
            if (panels.length > 0) {
                this.maxSteps = panels.length - 1;
                console.log('[AutoStep] Max step:', this.maxSteps);
            }
            return this.maxSteps;
        },
        
        getActiveCharmsCount() {
            const allActive = document.querySelectorAll('.cpb-option.cpb-active');
            return Math.max(0, allActive.length - this.config.skipFirstOptions);
        },
        
        getCurrentStepIndex() {
            const container = document.querySelector('.cpb-panels-container');
            if (!container) return 0;
            const match = container.className.match(/cpb-current-tab-index-(\d+)/);
            return match ? parseInt(match[1]) : 0;
        },
        
        calculateTargetStep(charmCount) {
            if (charmCount === 0) return 1;
            
            let targetStep = charmCount + 1;
            
            if (!this.maxSteps) {
                this.calculateMaxSteps();
            }
            
            if (this.maxSteps && targetStep > this.maxSteps) {
                if (this.config.endBehavior === 'loop') {
                    targetStep = 2;
                    console.log('[AutoStep] Loop');
                } else {
                    targetStep = this.maxSteps;
                    console.log('[AutoStep] Stop');
                }
            }
            
            return targetStep;
        },
        
        advanceToStep(targetStep) {
            if (this.isManualChange) return false;
            
            const currentStep = this.getCurrentStepIndex();
            
            if (this.config.endBehavior === 'stop' && 
                this.maxSteps && 
                currentStep >= this.maxSteps) {
                console.log('[AutoStep] Stop mode attivo');
                return false;
            }
            
            if (currentStep === targetStep) return false;
            
            console.log(`[AutoStep] ${currentStep} → ${targetStep}`);
            
            const container = document.querySelector('.cpb-panels-container');
            if (!container) return false;
            
            this.isManualChange = true;
            
            // Cambio classe SEMPLICE - come versione DEBUG
            container.className = container.className.replace(/cpb-current-tab-index-\d+/g, '').trim();
            container.classList.add(`cpb-current-tab-index-${targetStep}`);
            
            setTimeout(() => {
                this.isManualChange = false;
            }, this.config.manualChangeDelay);
            
            return true;
        },
        
        handleCharmSelection() {
            if (this.isManualChange) return;
            
            clearTimeout(this.changeTimeout);
            
            this.changeTimeout = setTimeout(() => {
                const currentCharmCount = this.getActiveCharmsCount();
                
                if (currentCharmCount > this.lastActiveCount) {
                    const targetStep = this.calculateTargetStep(currentCharmCount);
                    this.advanceToStep(targetStep);
                }
                
                this.lastActiveCount = currentCharmCount;
            }, this.config.delayBeforeAdvance);
        },
        
        setupMutationObserver() {
            if (this.observerActive) return;
            
            const targetNode = document.querySelector('#product-builder, .cpb-root');
            if (!targetNode) return;
            
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const target = mutation.target;
                        if (target.className && target.className.includes('cpb-option')) {
                            const isActive = target.className.includes('cpb-active');
                            if (isActive && !this.isManualChange) {
                                this.handleCharmSelection();
                            }
                        }
                    }
                });
            });
            
            observer.observe(targetNode, {
                attributes: true,
                attributeFilter: ['class'],
                subtree: true
            });
            
            this.observerActive = true;
        },
        
        setupEventListeners() {
            document.addEventListener('click', (e) => {
                const option = e.target.closest('.cpb-option, [class*="cpb-option"]');
                if (option && !this.isManualChange) {
                    setTimeout(() => this.handleCharmSelection(), 50);
                }
            }, true);
        },
        
        init() {
            if (this.initialized) return;
            
            const hasConfigurator = document.querySelector('#product-builder, .cpb-root');
            if (!hasConfigurator) return;
            
            console.log('[AutoStep] Init');
            console.log(`[AutoStep] Mode: ${this.config.endBehavior}`);
            
            this.calculateMaxSteps();
            this.lastActiveCount = this.getActiveCharmsCount();
            this.setupMutationObserver();
            this.setupEventListeners();
            
            this.initialized = true;
            console.log('[AutoStep] Ready');
        }
    };
    
    
    function initAutoStepSystem() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(() => AutoStepAdvance.init(), 1500);
            });
        } else {
            setTimeout(() => AutoStepAdvance.init(), 1000);
        }
        
        document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
            setTimeout(() => AutoStepAdvance.init(), 500);
        });
        
        window.addEventListener('load', () => {
            setTimeout(() => {
                if (!AutoStepAdvance.initialized) {
                    AutoStepAdvance.init();
                }
            }, 1500);
        });
    }
    
    console.log('[AutoStep] Load');
    initAutoStepSystem();
    
})();



/* ====================================
   FRECCIA SCROLL - HIDE DOPO SCROLL
   ==================================== */

(function() {
  'use strict';
  
  function initScrollArrow() {
    const containers = document.querySelectorAll('.cpb-category-options-container.img');
    
    containers.forEach(container => {
      container.addEventListener('scroll', function() {
        if (this.scrollLeft > 10) {
          this.classList.add('pr-scrolled');
        }
      }, { passive: true });
    });
  }
  
  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollArrow);
  } else {
    initScrollArrow();
  }
  
  // Re-init per nuove categorie
  const observer = new MutationObserver(() => {
    setTimeout(initScrollArrow, 100);
  });
  
  const cpbContainer = document.querySelector('.cpb-canvas-wrapper') || document.body;
  observer.observe(cpbContainer, {
    childList: true,
    subtree: true
  });
  
})();

// const fixDesctopSticky = () => {
//     if (window.innerWidth > 999) {
//         const preview = document.querySelector('.cpb-preview-sticky')
//         const height = preview.clientHeight;
//         const container = document.querySelector('.cpb-preview-layers > div')
//         container.style.minHeight = `${height}px`
//     }
// }

// const selectNextStep = () => {
//     const nextStepBtn = document.querySelector('[data-intro="Advance To Next Tab"]')
//     nextStepBtn.click()
// }

// const autoStepSelect = () => {
//     const currentCategory = document.querySelectorAll('.cpb-panels-tabs .cpb-category-img')
//     currentCategory.forEach(cat => {
//         const options = cat.querySelectorAll('.option.option-type-img')
//         console.log(options, 'options')
//         options.forEach(opt => {
//             opt.addEventListener('click', () => {
//                 setTimeout(() => {
//                     selectNextStep()
//                 })
//             })
//         })
//     })
// }

// async function frontendApiCategoriesInit() {
//   const extraClass = 'cpb_metal_color--js';
//   const product = CPB.getStore().getState().Product;
//   const wrapper = document.createElement('div');
//   wrapper.className = 'cpb-custom-product-actions';

//   const extraClasses = { size: 'cpb_change_size--js' };
//   const FrontendApi = await window.CPB.createFrontApi('FROCWEC233CN1!Dddv@1241D@FscC1C33');
//   const { panels } = FrontendApi.State.Product


//   panels[0].categories.forEach((cat) => {
//     const category = document.querySelector(`[data-category-id="${cat.id}"]`);
//     const extraClass = cat.extraClassName
//     if (!category) return;

//     const clone = category.cloneNode(true);

//     const cloneOptions = clone.querySelectorAll('.cpb-option');

//     cloneOptions.forEach((optionElem, optionIndex) => {
//       let panelObj = panels[0], categoryObj = cat, optionObj;

//       if (!categoryObj) return;

//       optionObj = categoryObj.options[optionIndex];

//       const img = optionElem.querySelector('.cpb-option-tooltip-img');
//       if (img && optionObj.option && optionObj.option.data) {
//         img.src = optionObj.option.data.value;
//       }

//       optionElem.addEventListener('click', () => {
//         console.log(cat, 'cat')
//         console.log(optionObj, 'optionObj')
//         if (optionElem.classList.contains('cpb-active')) return;

//         cloneOptions.forEach(opt => opt.classList.remove('cpb-active'));
//         optionElem.classList.add('cpb-active');

//         FrontendApi.updateOptions({
//           panel: panelObj,
//           category: categoryObj,
//           options: [optionObj]
//         });
//       });
//     });

//     wrapper.appendChild(clone);
//   });

  
//     const test = document.querySelector('.cpb-panels-container div:nth-child(1)')
//     test.prepend(wrapper)
//     selectNextStep()
// }

// document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function(event) {
//     console.log('step change')
//     autoStepSelect()
// })


// document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
//     frontendApiCategoriesInit()
//     fixDesctopSticky()
//     if (window.innerWidth < 999) {
//         const previewContainer = document.querySelector('.cpb-preview-container');
//         const panelContainer = document.querySelector('.cpb-panels-container');
//         const previewLayers = document.querySelector('.cpb-preview-layers');
//         const productBuilder = document.querySelector('#product-builder');
//         const height = previewContainer.clientHeight;

//         function updatePadding() {
//             setTimeout(() => {
//                 panelContainer.style.setProperty("--padding", `${height + 50}px`);
//                 previewLayers.style.setProperty("--padding", `${height}px`);
//             }, 500);
//         }

//         function togglePreviewVisibility() {
//             const rect = productBuilder.getBoundingClientRect();
//             if (rect.bottom < height || rect.top > window.innerHeight) {
//                 previewContainer.classList.add('hidden-preview');
//             } else {
//                 previewContainer.classList.remove('hidden-preview');
//             }
//         }

//         updatePadding();
//         togglePreviewVisibility();

//         window.addEventListener('scroll', togglePreviewVisibility);
//         window.addEventListener('resize', () => {
//             updatePadding();
//             togglePreviewVisibility();
//         });
//     }
// });

